// import React from "react";
// import Slider from "react-slick";

// const Testimonials = () => {
 


//   const testimonials = [
//   {
//     name: "Mr. Gorakh Paithane",
//     company: "Corporate Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "Our organization has been regularly using the services of Pune Corporate Cars, and the experience has been excellent throughout. They maintain high service standards, ensure driver professionalism, and deliver timely support for all travel schedules. Their operations team is responsive and cooperative, making corporate mobility smooth and stress-free.",
//     color: "#0A3D62",
//   },
//   {
//     name: "Miss. Pratiksha Nalawade",
//     company: "Corporate Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "Pune Corporate Cars India Pvt. Ltd. has consistently delivered exceptional service for our corporate travel requirements. Their fleet is well-maintained, drivers are punctual and professionally trained, and coordination is seamless. Highly recommended for reliable corporate mobility.",
//     color: "#1B4F72",
//   },
//   {
//     name: "Mr. Ali Sayyad",
//     company: "Business Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "Pune Corporate Cars India Private Limited offers Pune’s best tech-enabled corporate car rental service. GPS tracking, online booking, digital invoicing, and real-time trip monitoring make them ideal for modern businesses seeking efficient employee transport and executive mobility.",
//     color: "#154360",
//   },
//   {
//     name: "Mr. Prashant Savalkar",
//     company: "Corporate Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "Outstanding service with on-time arrival, well-maintained vehicles, and courteous drivers. The entire experience was smooth, safe, and highly professional. I would definitely recommend their services for business and personal travel.",
//     color: "#0E3C6E",
//   },
//   {
//     name: "Miss. Hima Pradhan",
//     company: "Corporate Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "Pune Corporate Cars India Pvt. Ltd. has proven to be a highly dependable transportation partner. Clean vehicles, disciplined drivers, and well-coordinated operations make them an excellent choice for corporate travel.",
//     color: "#1A5276",
//   },
//   {
//     name: "Mr. Rohit Shere",
//     company: "Corporate Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "Consistently dependable corporate car rental services with excellent vehicle cleanliness, punctuality, and professional driver behavior. Every assignment has been executed smoothly and efficiently.",
//     color: "#21618C",
//   },
//   {
//     name: "Mr. Mangal Patil",
//     company: "Corporate Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "Our company uses Pune Corporate Cars for multiple employee movements, and the experience has always been outstanding. Well-maintained vehicles and a responsive 24×7 support team make them truly dependable.",
//     color: "#1F618D",
//   },
//   {
//     name: "Mr. Amol Gavhane",
//     company: "Corporate Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "We are extremely satisfied with Pune Corporate Cars India Pvt. Ltd. Vehicles are clean, punctual, and well-maintained. Their drivers and operations team handle even urgent requirements seamlessly.",
//     color: "#2874A6",
//   },
//   {
//     name: "Mr. Kalpesh Rajole",
//     company: "Verified Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "Had a great experience with Pune Corporate Cars Pvt. Ltd. The car was spotless, arrived on time, and the driver was extremely courteous. Booking was smooth and hassle-free. Will definitely choose them again.",
//     color: "#2E86C1",
//   },
//   {
//     name: "Mr. Aditya Bhise",
//     company: "Corporate Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "If you’re looking for reliable and top-notch corporate car rental services in Pune, Pune Corporate Cars India Private Limited is the best. Professional chauffeurs, well-maintained fleet, and excellent customer support.",
//     color: "#1B4F72",
//   },
//   {
//     name: "Miss. Sakshi Nanvare",
//     company: "Corporate Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "Excellent service quality with uniformed drivers, good driving skills, clean cars, polite language, and thoughtful amenities like water bottles and tissues. Very happy with the service.",
//     color: "#154360",
//   },
//   {
//     name: "Mr. Mayur Shinde",
//     company: "Corporate Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "Great experience with Pune Corporate Cars. The service was punctual, vehicles were clean, and the driver was professional and courteous. Highly recommended for corporate travel needs in Pune.",
//     color: "#0E3C6E",
//   },
//   {
//     name: "Mr. Malum Nahi",
//     company: "Corporate Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "Excellent corporate car rental experience. Clean and comfortable cars, punctual and professional drivers, and impressive coordination even in last-minute situations. Highly recommended for businesses.",
//     color: "#1A5276",
//   },
//   {
//     name: "Miss. Hima Pradhan",
//     company: "Enterprise Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "Timely operations, customer-focused service, and disciplined drivers make Pune Corporate Cars India Pvt. Ltd. a trusted partner for corporate mobility. Their service quality truly stands out.",
//     color: "#21618C",
//   },
//   {
//     name: "Mr. Amol Gavhane",
//     company: "Business Client",
//     logo: "/images/logos/google.png",
//     feedback:
//       "Professional drivers, excellent coordination, and flexibility in handling schedule changes have made Pune Corporate Cars an invaluable partner for our corporate transportation needs.",
//     color: "#2874A6",
//   },
// ];


//   const settings = {
//     autoplay: true,
//     autoplaySpeed: 3000,
//     dots: true,
//     infinite: true,
//     speed: 800,
//     arrows: false,

//     slidesToShow: 3,        // ⭐ DESKTOP = 3
//     slidesToScroll: 1,

//     responsive: [
//       {
//         breakpoint: 991,     // Tablets
//         settings: {
//           slidesToShow: 2,
//         },
//       },
//       {
//         breakpoint: 768,     // ⭐ MOBILE = 1
//         settings: {
//           slidesToShow: 1,
//         },
//       },
//     ],
//   };

//   return (
//     <section className="testimonials-section">
//       <div className="container">
//         <h2 className="section-title text-dark">What Our Clients Say</h2>

//         <Slider {...settings}>
//           {testimonials.map((item, i) => (
//             <div key={i}>
//               <div
//                 className="testimonial-card "
//                 style={{ borderColor: item.color }}
//               >
//                 <div className="testimonial-header">
//                   {/* <img src={item.logo} alt={item.company} className="company-logo" /> */}
//                 </div>

//                 <p className="feedback">“{item.feedback}”</p>

//                 <div className="client-info">
//                   <h5>{item.name}</h5>
//                   <span>{item.company}</span>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </section>
//   );
// };

// export default Testimonials;











import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const Testimonials = () => {
  
  const testimonials = [
  {
    name: "Mr. Gorakh Paithane",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "Our organization has been regularly using the services of Pune Corporate Cars, and the experience has been excellent throughout. They maintain high service standards, ensure driver professionalism, and deliver timely support for all travel schedules. Their operations team is responsive and cooperative, making corporate mobility smooth and stress-free.",
    color: "#0A3D62",
  },
  {
    name: "Miss. Pratiksha Nalawade",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "Pune Corporate Cars India Pvt. Ltd. has consistently delivered exceptional service for our corporate travel requirements. Their fleet is well-maintained, drivers are punctual and professionally trained, and coordination is seamless. Highly recommended for reliable corporate mobility.",
    color: "#1B4F72",
  },
  {
    name: "Mr. Ali Sayyad",
    company: "Business Client",
    logo: "/images/logos/google.png",
    feedback:
      "Pune Corporate Cars India Private Limited offers Pune’s best tech-enabled corporate car rental service. GPS tracking, online booking, digital invoicing, and real-time trip monitoring make them ideal for modern businesses seeking efficient employee transport and executive mobility.",
    color: "#154360",
  },
  {
    name: "Mr. Prashant Savalkar",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "Outstanding service with on-time arrival, well-maintained vehicles, and courteous drivers. The entire experience was smooth, safe, and highly professional. I would definitely recommend their services for business and personal travel.",
    color: "#0E3C6E",
  },
  {
    name: "Miss. Hima Pradhan",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "Pune Corporate Cars India Pvt. Ltd. has proven to be a highly dependable transportation partner. Clean vehicles, disciplined drivers, and well-coordinated operations make them an excellent choice for corporate travel.",
    color: "#1A5276",
  },
  {
    name: "Mr. Rohit Shere",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "Consistently dependable corporate car rental services with excellent vehicle cleanliness, punctuality, and professional driver behavior. Every assignment has been executed smoothly and efficiently.",
    color: "#21618C",
  },
  {
    name: "Mr. Mangal Patil",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "Our company uses Pune Corporate Cars for multiple employee movements, and the experience has always been outstanding. Well-maintained vehicles and a responsive 24×7 support team make them truly dependable.",
    color: "#1F618D",
  },
  {
    name: "Mr. Amol Gavhane",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "We are extremely satisfied with Pune Corporate Cars India Pvt. Ltd. Vehicles are clean, punctual, and well-maintained. Their drivers and operations team handle even urgent requirements seamlessly.",
    color: "#2874A6",
  },
  {
    name: "Mr. Kalpesh Rajole",
    company: "Verified Client",
    logo: "/images/logos/google.png",
    feedback:
      "Had a great experience with Pune Corporate Cars Pvt. Ltd. The car was spotless, arrived on time, and the driver was extremely courteous. Booking was smooth and hassle-free. Will definitely choose them again.",
    color: "#2E86C1",
  },
  {
    name: "Mr. Aditya Bhise",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "If you’re looking for reliable and top-notch corporate car rental services in Pune, Pune Corporate Cars India Private Limited is the best. Professional chauffeurs, well-maintained fleet, and excellent customer support.",
    color: "#1B4F72",
  },
  {
    name: "Miss. Sakshi Nanvare",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "Excellent service quality with uniformed drivers, good driving skills, clean cars, polite language, and thoughtful amenities like water bottles and tissues. Very happy with the service.",
    color: "#154360",
  },
  {
    name: "Mr. Mayur Shinde",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "Great experience with Pune Corporate Cars. The service was punctual, vehicles were clean, and the driver was professional and courteous. Highly recommended for corporate travel needs in Pune.",
    color: "#0E3C6E",
  },
  {
    name: "Mr. Malum Nahi",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "Excellent corporate car rental experience. Clean and comfortable cars, punctual and professional drivers, and impressive coordination even in last-minute situations. Highly recommended for businesses.",
    color: "#1A5276",
  },
  {
    name: "Miss. Hima Pradhan",
    company: "Enterprise Client",
    logo: "/images/logos/google.png",
    feedback:
      "Timely operations, customer-focused service, and disciplined drivers make Pune Corporate Cars India Pvt. Ltd. a trusted partner for corporate mobility. Their service quality truly stands out.",
    color: "#21618C",
  },
  {
    name: "Mr. Amol Gavhane",
    company: "Business Client",
    logo: "/images/logos/google.png",
    feedback:
      "Professional drivers, excellent coordination, and flexibility in handling schedule changes have made Pune Corporate Cars an invaluable partner for our corporate transportation needs.",
    color: "#2874A6",
  },
];

  return (
    <section className="testimonials-section p-0">
      <div className="container">
        <h2 className="section-title text-dark text-center">
          What Our Clients Say
        </h2>

        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          spaceBetween={20}
          slidesPerView={3}
          breakpoints={{
            0: {
              slidesPerView: 1, // ✅ MOBILE
            },
            768: {
              slidesPerView: 2, // TABLET
            },
            1024: {
              slidesPerView: 3, // DESKTOP
            },
          }}
        >
          {testimonials.map((item, i) => (
            <SwiperSlide key={i}>
              <div className="testimonial-card py">
                <p className="feedback">“{item.feedback}”</p>
                <div className="client-info">
                  <h5>{item.name}</h5>
                  <span>{item.company}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
